import SafeAreaHeaderContainer from 'navigation/SafeAreaHeaderContainer';
import styled from 'styled-components/native';
import { isWeb } from 'utils/deviceUtils';

export const StackHeaderContainer = styled(SafeAreaHeaderContainer)<{
  headerMode: 'screen' | 'float';
  tabBarHeight: number;
  background: string;
}>`
  margin-top: ${(p) => (isWeb ? p.tabBarHeight : 0)}px;
  position: ${({ headerMode }) =>
    headerMode === 'float' && !isWeb ? 'absolute' : 'relative'};
  background-color: ${({ background, headerMode }) =>
    headerMode === 'float' ? 'transparent' : background};
`;

export const TitleWrapper = styled.View<{ mr: boolean }>`
  flex: 0 1 auto;
  margin: 0px 15px;
  width: 100%;
  margin-right: ${(p) => (p.mr ? 48 : 0)}px;
`;
